import SectionHeading from "./SectionHeading";
import { serviceItems } from "@/mocks/home";

export default function RepairServices() {
  return (
    <section id="service" className="w-full bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="Repair Service"
          title="맥 전용 장비로"
          highlight="정확하게 수리합니다"
          desc="일반 노트북과 맥은 회로 구조가 다릅니다. 맥 전용 진단 장비와 회로도로 원인을 정확히 찾아 불필요한 교체 없이 수리합니다."
        />

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {serviceItems.map((item, index) => (
            <article
              key={item.id}
              className="reveal group flex flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300 hover:bg-primary-50/60"
              style={{ transitionDelay: `${index * 60}ms` }}
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-5 font-heading text-xl font-black text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2.5 font-body text-sm leading-relaxed text-foreground-600">
                {item.desc}
              </p>
              <ul className="mt-5 flex flex-col gap-2 border-t border-background-200 pt-4">
                {item.points.map((point) => (
                  <li key={point} className="flex items-center gap-2 font-label text-sm font-medium text-foreground-700">
                    <i className="ri-check-line text-accent-600"></i>
                    {point}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        {/* Feature strip */}
        <div className="reveal relative mt-16 overflow-hidden rounded-lg">
          <img
            src="https://readdy.ai/api/search-image?query=Macro%20shot%20of%20a%20laptop%20logic%20board%20with%20golden%20copper%20circuit%20traces%20and%20tiny%20electronic%20components%2C%20dark%20teal%20and%20deep%20blue%20tones%2C%20shallow%20depth%20of%20field%2C%20professional%20electronics%20microscope%20photography%2C%20clean%20and%20precise%20composition&width=1600&height=560&seq=feature-logicboard-mfx&orientation=landscape"
            alt="맥북 로직보드의 정밀한 회로 구조"
            title="맥픽스 로직보드 회로 정밀 수리"
            className="h-[360px] w-full object-cover object-top md:h-[380px]"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/92 via-foreground-950/70 to-foreground-950/30"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="w-full px-6 md:px-12">
              <div className="max-w-xl">
                <span className="font-label text-sm font-bold uppercase tracking-[0.18em] text-accent-300">
                  Logic Board Focus
                </span>
                <h3 className="mt-3 font-heading text-2xl font-black leading-tight text-background-50 md:text-4xl">
                  회로 한 가닥까지
                  <br />
                  책임지는 수리
                </h3>
                <p className="mt-4 font-body text-sm leading-relaxed text-background-200 md:text-base">
                  3D 현미경과 회로도 분석 장비로 미세 단선까지 추적합니다. 진단 결과와 수리
                  과정을 사진으로 공유해 안심하고 맡기실 수 있습니다.
                </p>
                <div className="mt-6 flex flex-wrap gap-2.5">
                  {["3D 현미경 진단", "회로도 기반 분석", "BGA 리볼링", "수리 과정 사진 공유"].map(
                    (chip) => (
                      <span
                        key={chip}
                        className="rounded-full border border-background-50/25 bg-background-50/10 px-3.5 py-1.5 font-label text-xs font-bold text-background-100 backdrop-blur-sm md:text-sm"
                      >
                        {chip}
                      </span>
                    ),
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}